import React, { FC } from 'react';
import { Img } from 'react-image';
import { Slider } from '@alifd/next';
import { formatTime } from '@/utils';
import { Drawer, Icon, Progress, Loading } from '@b-design/fusion';
import FlowDrawerHeader from '../flowDrawerHeader';
import $i18n from '../../../../../../i18n';
import './index.less';

/**
 * 工作流详情抽屉
 */
interface PropsType {
  visible: boolean;
  setVisible: (value: boolean) => void;
  record: any;
}

const InfoList = [
  {
    key: 'description',
    label: $i18n.get({
      id: 'aopf.component.viewFlowDetailsDrawer.WorkflowDescription',
      dm: '工作流描述',
    }),
  },
  {
    key: 'type',
    label: $i18n.get({ id: 'aopf.component.viewFlowDetailsDrawer.Type', dm: '类型' }),
  },
  {
    key: 'version',
    label: $i18n.get({ id: 'aopf.component.viewFlowDetailsDrawer.VersionNumber', dm: '版本号' }),
    formatValue: (value: string) => (value ? `V ${value}` : '-'),
  },
  {
    key: 'gmtCreate',
    label: $i18n.get({
      id: 'aopf.component.viewFlowDetailsDrawer.VersionReleaseTime',
      dm: '版本发布时间',
    }),
    formatValue: (value: string) => (value ? formatTime(value) : '-'),
  },
];

const ViewFlowDetailsDrawer: FC<PropsType> = ({ visible, setVisible, record }) => {
  const list = record.imageList || [];
  // [
  //   'https://gw.alicdn.com/imgextra/i1/O1CN01KyexfZ29MKXE2r9vj_!!6000000008053-2-tps-2214-1206.png',
  //   'https://gw.alicdn.com/imgextra/i1/O1CN01KyexfZ29MKXE2r9vj_!!6000000008053-2-tps-2214-1206.png',
  //   'https://gw.alicdn.com/imgextra/i1/O1CN01KyexfZ29MKXE2r9vj_!!6000000008053-2-tps-2214-1206.png',
  // ]

  return (
    <Drawer
      visible={visible}
      title={$i18n.get({
        id: 'aopf.component.viewFlowDetailsDrawer.WorkflowDetails',
        dm: '工作流详情',
      })}
      width={800}
      onClose={() => setVisible(false)}
      className="view-flow-details-drawer"
    >
      <FlowDrawerHeader record={record} />
      <Slider
        autoplay={false}
        prevArrow={
          <div>
            <Icon type="arrow--left" size="xs" />
          </div>
        }
        nextArrow={
          <div>
            <Icon type="arrow--right" size="xs" />
          </div>
        }
        dotsRender={(index, current) => {
          if (index === 0) {
            return (
              <Progress
                size="small"
                percent={((current + 1) / list.length) * 100}
                style={{ width: '200px' }}
                color={getComputedStyle(document.documentElement).getPropertyValue('--superapp-primary-1') || '#2561F5'}
                backgroundColor="#EBECF0"
                textRender={() => ''}
              />
            );
          }
        }}
      >
        {list.map((item) => (
          <div key={item} className="flow-slider-item">
            <Img
              src={item}
              loader={
                <Loading>
                  <img src="https://gw.alicdn.com/imgextra/i4/O1CN01enTL421dJynvEf6VP_!!6000000003716-0-tps-2208-1200.jpg" />
                </Loading>
              }
              unloader={
                <img src="https://gw.alicdn.com/imgextra/i4/O1CN01enTL421dJynvEf6VP_!!6000000003716-0-tps-2208-1200.jpg" />
              }
            />
          </div>
        ))}
      </Slider>
      <div className="info-content">
        <div className="info-title">
          <span className="title">
            {$i18n.get({
              id: 'aopf.component.viewFlowDetailsDrawer.WorkflowIntroduction',
              dm: '工作流简介',
            })}
          </span>
          <span className="update-time">
            {$i18n.get({
              id: 'aopf.component.viewFlowDetailsDrawer.LastUpdated',
              dm: '最后更新时间：',
            })}
            {formatTime(record?.gmtModified)}
          </span>
        </div>
        <div className="info-list">
          {InfoList.map((v) => (
            <div className="info-item" key={v.key}>
              <div className="item-title">
                <span className="dot" />
                <span className="label">{v.label}</span>
              </div>
              <div className="text">
                {v.formatValue ? v.formatValue(record[v.key]) : record[v.key] || '-'}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Drawer>
  );
};

export default ViewFlowDetailsDrawer;
